import React, { useState } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { connect } from "react-redux";

const select = ({ interactiveMap }) => ({
  blogIndexInView: interactiveMap.blogIndexInView - 1
});

function MapContainer({ google, events, blogIndexInView }) {
  const [selectedMarker, setSelectedMarker] = useState({});
  const [showInfoWindow, setShowInfoWindow] = useState(false);

  return (
    <Map
      initialCenter={getMapCenter(events, 0)}
      center={getMapCenter(events, blogIndexInView)}
      onClick={() => setShowInfoWindow(false)}
      google={google}
      zoom={10}
    >
      {events.map(({ location }, i) => (
        <Marker
          name={location.name}
          icon={getMarkerIcon(google, i, blogIndexInView)}
          position={location.coordinates}
          onClick={(props, marker, e) => {
            setSelectedMarker(marker);
            setShowInfoWindow(true);
          }}
        />
      ))}

      <InfoWindow marker={selectedMarker} visible={showInfoWindow}>
        <p>{selectedMarker.name}</p>
      </InfoWindow>
    </Map>
  );
}

const ConnectedMap = connect(select)(MapContainer);

export default GoogleApiWrapper({
  //   apiKey: YOUR_GOOGLE_API_KEY_GOES_HERE
})(ConnectedMap);

function getMarkerIcon(google, index, blogIndexInView) {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    strokeColor:
      blogIndexInView === index ? "turquoise" : "rgba(255,255,255,0.5)",
    scale: 6
  };
}

function getMapCenter(events, blogIndexInView) {
  return events[blogIndexInView].location.coordinates;
}
